import { View } from 'react-native';

import { cn } from '@/components/ui/cn';

import { Check } from './Check';

/** Signal-red rounded-square check used in the run mockups. */
export function Tick({ checked, size = 'md' }: { checked: boolean; size?: 'sm' | 'md' }) {
  const box =
    size === 'sm' ? 'h-[18px] w-[18px] rounded-[5px]' : 'h-[22px] w-[22px] rounded-[7px]';
  if (!checked) {
    return <View className={cn(box, 'border-2 border-border-strong')} />;
  }
  return (
    <View className={cn(box, 'items-center justify-center bg-signal')}>
      <Check />
    </View>
  );
}
